var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpster22M3Lv22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "74 190 688 311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Roll_Of_Dumpster_22m3_LV22_svg__st0{fill:currentColor}.Roll_Of_Dumpster_22m3_LV22_svg__st1{opacity:.4;fill:#1d1d1b;enable-background:new}.Roll_Of_Dumpster_22m3_LV22_svg__st2{fill:#1d1d1b;enable-background:new;opacity:.1}.Roll_Of_Dumpster_22m3_LV22_svg__st3{opacity:.3}.Roll_Of_Dumpster_22m3_LV22_svg__st5{opacity:.3;fill:#040506;enable-background:new}.Roll_Of_Dumpster_22m3_LV22_svg__st6,.Roll_Of_Dumpster_22m3_LV22_svg__st7{fill:#040506;enable-background:new}.Roll_Of_Dumpster_22m3_LV22_svg__st8{enable-background:new}.Roll_Of_Dumpster_22m3_LV22_svg__st6{opacity:.1}.Roll_Of_Dumpster_22m3_LV22_svg__st7{opacity:.8}.Roll_Of_Dumpster_22m3_LV22_svg__st8{opacity:.1;fill:#fff}.Roll_Of_Dumpster_22m3_LV22_svg__st10{fill:#010101}.Roll_Of_Dumpster_22m3_LV22_svg__st9{opacity:.2;fill:#010101}.Roll_Of_Dumpster_22m3_LV22_svg__st10{opacity:.3}.Roll_Of_Dumpster_22m3_LV22_svg__st12{opacity:.2;fill:#fff;enable-background:new}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 363 235"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 363,
    height: 235,
    href: ""
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: "100%",
    height: "100%",
    viewBox: "0 0 74 103"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 74,
    height: 103,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Container_2_00000033360607865105986610000005360103184672614793_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Bakgrund_\\xC4ndra_F\\xE4rg_00000166664356244691379810000014738303428280422583_",
    d: "m75 213.3 206.8-23.1L762 256.6v14.1l-5.7 1.3.3 112.5-22 57.8-26.2 9.2v18.4l-5.3 3.2L693 477l-31.7-8.5-14 5v19l-7.8 4.8-10.8 3.7-32.1-9.6-15.1 5.7-76.4-23.9-34.9 11.5-13.5-4.1.2-22.5-21.1-6.4-36 11-12.2-4.1v-21.8l-14.5-4.6-37.2 10.1-12.2-3.4v-22.3l-8.5-2.5-38.8 9.9-10.6-3.2v-22.3l-3.7-.9-40.2 9.4-9.4-3v-21.8l-40.2 8.7-9.2-2.8v-19l-37.4 7.3-8.3-2.3v-22l-1.8-.2-28 5.5v5l-4.6.7-7.8-2.1.4-135.9-.9-.2.3-11.6z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_60_x25__00000005237214566855956140000008412896059360569238_",
    d: "m280.7 193.6.1 53.6-181.4-33.5 181.3-20.1z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_40_x25_",
    d: "m280.7 193.6.1 53.6L553 296.5l186-39-458.3-63.9z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_22m3_LV22_LogoA",
    transform: "translate(88.9,157.9)",
    d: "m74.389 111.3h228.84v78.931h-228.84z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Roll_Of_Dumpster_22m3_LV22_LogoB",
    transform: "translate(88.9,157.9)",
    d: "m576.37 199.88h57.921v44.86h-57.921z",
    fill: "url(#pattern-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_30_x25__00000181065148158912837200000007017045807382542745_",
    transform: "translate(312.937 70.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25204",
    d: "m348.4 397.6 27.2-9.8-.1 17-27.1-7.2z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25209",
    d: "m315.7 430.4 7.5-4.9 11.2-3.7-7.8 4.8-10.9 3.8z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25210",
    d: "m379.8 406.1 5.5-3.7 10.1-3.3-5.3 3.2-10.3 3.8z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_30_x25__00000137849312361244581830000003746067145115477653_",
    transform: "translate(4.632 20.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25211",
    d: "m465.5 464.2 34.9-11.5-29.8-45-1.3-125-4.3-.9.5 182.4",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25212",
    d: "m431.1 431.1-36 11-1.6-174.6 6.1 1.4.3 119.8 31.2 42.4z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25213",
    d: "m310.6 393.5-38.8 9.9-.5-160 5.1.9.2 109.5 34 39.7z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25214",
    d: "m368.5 411.6-37.2 10.1-1.3-166.8 5.5 1 .2 114.1 32.8 41.6z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25215",
    d: "m257.6 377-40.2 9.4-.3-153.3 4.9 1.1.5 104.9 35.1 37.9z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25216",
    d: "m208 360.7-35.7-35.6.1-100.9-4.5-.8v146.9l40.2-8.7-.1-.9",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25217",
    d: "m158.6 343 .1 5.5-37.4 7.3-.2-141.5 5 1.1.1 97.2 32.4 30.4",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25218",
    d: "m111.2 331.3-28 5.5v5l-4.6.7-.1-136.5 4.8 1.1v93.3l27.9 30.9z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_10_x25__00000169556192460496101520000018272193532120843393_",
    d: "M553 301.2v17.2l209-47.7v-14.1l-209 44.6z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_30-80_x25__00000003784025586284950380000005459046236462634383_",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st3",
    transform: "translate(7.324 73.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25219",
    d: "m467.9 354.3 77.5 22.4 28.7 46.6-76.4-23.9-29.8-45.1z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25220",
    d: "m397.2 335.3 51.9 14.2.5 34.7-21.1-6.4-31.3-42.5z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25221",
    d: "m333 316.7 32.9 41.4 14.3 4.5-.2-32.8-47-13.1z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25222",
    d: "m274 300.4 42.5 12v30.2l-8.5-2.5-34-39.7z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25223",
    d: "m258.6 324.5-.1-28.1-38.7-10.7 35.2 37.9 3.6.9z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25224",
    d: "M205.3 307.4v-25.8l-35.8-9.8 35.8 35.6z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25225",
    d: "m155.9 289.7.1-21.3-32.5-9.1 32.4 30.4z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Path_25226",
    d: "m108.5 278 1.8.2-.1-22.5-29.6-8.5 27.9 30.8z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Highlight_10_x25__00000021107114497946070560000009940652570821201055_",
    d: "M75 225.1v-11.8l478 87.9v17.2l-83.3-16.1.5 182.4-13.5-4.1-.2-181.1-58.3-11.5 1.6 174.6-12.2-4.1.1-172.9-53-10.2 1.3 166.8-12.2-3.4.1-165.7L276 264l.5 160-10.6-3.2-.1-158.6-44.1-8.4.3 153.3-9.4-3-.1-152.4-40.1-7.6V391l-9.2-2.8-.1-146-37.5-7.2.2 141.5-8.3-2.3-.2-140.8-34.3-6.7.1 136.5-7.8-2.1.4-135.9",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_20_x25__00000095308562833959125760000000834389210161685644_",
    d: "m677.9 327.1.8 1.2.5 1 1 .9c3.6 1.9 4.3-1.2 4.6-2.5.2-1.2-.7-4-1.3-5.3-.5-1.3-3.3-3.6-3.3-3.6l-2.6-1.7v-1.2l8.2 1.5v25.2l-4.6 7.8v10l1-.3v-1.9l6.8-1.7v-5.3l9.4 2.1v120l-5.5 3.7.2.1 10.1-3.9 5.3-3.2v-18.4l26.2-9.2 22-57.8-.4-112.6 5.7-1.3v-14.1l-208.8 44.6-.5 149.4 28.7 46.6 15.4-5.8-.3.1 28-9.7-.5-117.9.5-61.7 4.3-1-.2 59.5 11.4-20.6v-2.8l7.5-14.1 1.1-.5 5.4 1 3.2.6-1 .6-19.8 38.1-.1 133.3-7.2 4.8 10.4-3.6 7.8-4.8v-19l14.3-5.1 26.8 7.2.1-17 3.9-1.6v-7.6l-45 15.8.1-4.5 41.4-14.6V369l1.1-.3 2.4-3.5v-7.7l-44.7 12.6V368l1.9-.6 3.6.8 1-.3v-1.7l23.5-6.6.2-32.5m10.7-7.8.3-31.8 4.1-.9.2 38.1-4.6-5.4z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Skugga_30_x25__00000168080693626256830670000002694098333093512838_",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.6 337.2 693.4 325l-.5-.6-4.2-5-1.9-2.3-1 .3v25.2l1-.3 11.5 10.9v120.1l10.1-3.4V343z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.2 360.1-.3-10.9-.7 1.1v9.9l-27 7.7-.3-12.7 2.5-4.7 1-.3V332c3.8-4.3 9.3-8.2 14.4-8.1 2.9.1 5.5 1.8 6.9 4.3.5 1.2 1.3 2 2.8 2.5 1.7.3 3.1-1 3.3-3.1 0 0 .7-6.8-7.3-10.5-1.4-.6-2.9-1.1-4.4-1.4-6.2-1.3-13.7 2.9-18.8 8l3.2.6-1 .6-5.8 11-14.2 26.9v133.5l11.2-3.7v-125l1.9-3.7 3-5.7.3-.5.5 10.7-5.7 1.6v7.6l44.9-12.9v-7.3l-10.4 2.7zm-53.4.6 11.4-20.7.5-41.6-11.7 2.8zm72.5-76-8.2 1.6.2 38.5 7.8 9.5z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Roll_Of_Dumpster_22m3_LV22_svg__Highlight_20_x25__00000011719112482929988470000009404655841676063104_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.7 193.6 1.1-3.4L762 256.6l-11.6 2.5-11.5-1.6z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553 296.5 185.9-39 11.5 1.6-197.1 42.2-478.3-88 206.8-23.1-1.1 3.4-181.3 20.1z",
    className: "Roll_Of_Dumpster_22m3_LV22_svg__st12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpster22M3Lv22);
export default __webpack_public_path__ + "static/media/Roll_Of_Dumpster_22m3_LV22.4cf402c6d42d3eec90c80e3bd2194e79.svg";
export { ForwardRef as ReactComponent };